"use client";

import { useMediaQuery } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import Image from "next/image";

export default function Testimonials() {
  const matches = useMediaQuery("(min-width:1024px)");

  const items = [
    {
      title: "Adani",
      image: "/images/brands/Adani.webp",
    },
    {
      title: "Seal of Karnataka",
      image: "/images/brands/Seal_of_Karnataka.webp",
    },
    {
      title: "IREP",
      image: "/images/brands/IREP.webp",
    },
    {
      title: "Delhi Capitals",
      image: "/images/brands/pngwing.com.webp",
    },
    {
      title: "Reliance",
      image: "/images/brands/Reliance.webp",
    },
  ];

  return (
    <div className="mb-4">
      <h4 className="text-center font-semibold text-xl md:text-4xl mb-2 md:mb-4">
        Trusted by Industry Leaders
      </h4>
      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={16}
        slidesPerView="auto"
        autoplay={!matches}
      >
        {items.map((item, index) => (
          <SwiperSlide key={index} className="md:max-w-[280px] max-w-[180px]">
            <Image
              src={item.image}
              alt={item.title}
              width={100}
              height={100}
              className="mx-auto"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
